


































































































































import Vue from 'vue';
import store from '../store';
import i18n from '../i18n';
import { routeEnterHelper } from '../helpers';

export default Vue.extend({
    data() {
        return {
            customer: {
                company: '',
                department: '',
                firstname: '',
                lastname: '',
                streetAddress: '',
                zip: '',
                city: '',
                country: '',
                phone: '',
                fax: '',
                mailAddress: '',
            },
            captcha: '',
            alert: '',
            quantity: 1,
            wasValidated: false,
            isProduction: process.env.NODE_ENV === 'production',
        };
    },
    computed: {
        productForOrder() {
            return store.state.productForOrder;
        },
        homePage() {
            return store.getters.homePage;
        },
        orderContent() {
            const product = store.state.productForOrder;
            let orderContent = '';
            if (product) {
                orderContent += this.$sanatizeText(product.name);
                if (product.articleNo) {
                    orderContent += ' - ' + this.$sanatizeText(product.articleNo);
                }
                orderContent += '\n';

                const po = product.options;
                store.state.attributes.forEach((attribute, key) => {
                    const optionId = String(po[attribute.id]);
                    const option = (optionId && attribute.options.find((o) => o.id === optionId)) || null;

                    if (option && option.label && option.articleNo !== '---') {
                        orderContent += ' - ';
                        orderContent += this.$sanatizeText(attribute.label).replace(/\s+/g, ' ');
                        orderContent += ' - ';
                        orderContent += this.$sanatizeText(option.label).replace(/\s+/g, ' ');
                        if (option.articleNo) {
                            orderContent += ' - ';
                            orderContent += this.$sanatizeText(option.articleNo).replace(/\s+/g, ' ');
                        }
                        orderContent += '\n';
                    }
                });

                let firstAccessory = true;
                if (product.accessoryTables) {
                    product.accessoryTables.forEach((accessoryTable) => {
                        accessoryTable.entries.forEach((entry) => {
                            if (entry.rowType === 'accessory' && entry.isSelected) {
                                if (firstAccessory) {
                                    orderContent += '\n';
                                    orderContent += i18n.t('trans.productAccessories');
                                    orderContent += '\n';
                                    firstAccessory = false;
                                }
                                orderContent += this.$sanatizeText(entry.articleNo || '').replace(/\s+/g, ' ');
                                orderContent += ' - ';
                                orderContent += this.$sanatizeText(entry.label || '').replace(/\s+/g, ' ');
                                orderContent += '\n';
                            }
                        });
                    });
                }
            }
            return orderContent;
        },
    },
    methods: {
        validateCaptcha(event: Event) {
            const input = event.target as HTMLInputElement;
            if (this.captcha !== '6') {
                input.setCustomValidity('validateCaptcha');
            } else {
                input.setCustomValidity('');
            }
        },
        handleSubmit(event: Event) {
            const form = event.target as HTMLFormElement;

            if (form.checkValidity() === true) {
                store.commit('ajaxModal', { on: true });
                store.dispatch('order', {
                    customer: this.customer,
                    product: this.orderContent,
                    consentMessage: this.$t('trans.orderPrivacyNotice'),
                }).then(() => {
                    this.$router.push({ name: 'sent' });
                }, (reason) => {
                    this.alert = reason;
                }).finally(() => {
                    store.commit('ajaxModal', { on: false });
                });
            }
            this.wasValidated = true;
        },
        fill() {
            this.customer.company = 'company';
            this.customer.department = 'department';
            this.customer.firstname = 'firstname';
            this.customer.lastname = 'lastname';
            this.customer.streetAddress = 'streetAddress';
            this.customer.zip = 'zip';
            this.customer.city = 'city';
            this.customer.country = 'country';
            this.customer.phone = 'phone';
            this.customer.fax = 'fax';
            this.customer.mailAddress = 'joerg.baumann@ercas.de';
            this.captcha = '6';
        },
    },
    beforeRouteEnter(to, from, next) {
        routeEnterHelper(store.state.productForOrder != null, from, next);
    },
});
